function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/** @module components/ProFooter */
import React from "react";
import { Icon, Alert } from "react-aiot";
import { request, rmlOpts, i18n, getMediaDialogNextZIndex } from "../util";
import { Modal } from ".";
import T from "i18n-react";
/**
 * Show a dialog box with a pro feature.
 *
 * @param [props.feature=undefined] {string} The feature to show
 * @extends React.Component
 */

var ProBox = /*#__PURE__*/function (_React$Component) {
  _inherits(ProBox, _React$Component);

  var _super = _createSuper(ProBox);

  function ProBox(props) {
    var _this;

    _classCallCheck(this, ProBox);

    _this = _super.call(this, props);

    _this.redirect = function () {
      window.open(rmlOpts.others.proUrl + "&feature=" + _this.props.feature, "_blank").focus();

      _this.props.onClose();
    };

    return _this;
  }

  _createClass(ProBox, [{
    key: "render",
    value: function render() {
      var title, modalContent;
      var feature = this.props.feature;

      if (feature) {
        var set = rmlOpts.others.lang.proFeatures[feature];
        title = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
          type: "lock"
        }), " ", set.title, " ", rmlOpts.others.lang.proBoxTitle);
        modalContent = /*#__PURE__*/React.createElement("div", null, !!set.image && /*#__PURE__*/React.createElement("img", {
          src: "https://assets.devowl.io/in-app/wp-real-media-library/".concat(set.image)
        }), /*#__PURE__*/React.createElement(T.p, {
          text: set.description
        }));
      }

      return /*#__PURE__*/React.createElement(Modal, {
        visible: !!modalContent,
        title: title,
        onOk: this.redirect,
        onCancel: this.props.onClose,
        cancelText: i18n("proBoxCancel"),
        okText: i18n("proBoxOk"),
        zIndex: getMediaDialogNextZIndex(),
        className: "rml-probox"
      }, modalContent);
    }
  }]);

  return ProBox;
}(React.Component);

function dismiss() {
  return _dismiss.apply(this, arguments);
}

function _dismiss() {
  _dismiss = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return request({
              location: {
                path: "/notice/lite",
                method: "DELETE"
              }
            });

          case 2:
            window.location.reload();

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _dismiss.apply(this, arguments);
}

var ProFooter = function ProFooter(_ref) {
  var _ref$dismissible = _ref.dismissible,
      dismissible = _ref$dismissible === void 0 ? false : _ref$dismissible,
      feature = _ref.feature;
  return /*#__PURE__*/React.createElement(Alert, {
    message: /*#__PURE__*/React.createElement("span", null, rmlOpts.others.lang.proFooterText, " \xB7", " ", /*#__PURE__*/React.createElement("a", {
      href: rmlOpts.others.proUrl + "&feature=" + feature,
      target: "_blank"
    }, rmlOpts.others.lang.proLearnMore), dismissible && /*#__PURE__*/React.createElement(React.Fragment, null, " ", "\xB7", " ", /*#__PURE__*/React.createElement("a", {
      onClick: dismiss,
      href: "#"
    }, rmlOpts.others.lang.proDismiss))),
    type: "info",
    style: {
      marginBottom: "10px"
    }
  });
};

export { ProFooter, ProBox };